import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=2106e258&scoped=true&lang=html&"
import script from "./Services.vue?vue&type=script&lang=js&"
export * from "./Services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106e258",
  null
  
)

export default component.exports